import { Outlet } from 'react-router-dom';
import { AppShell, Burger, Group, Image, Stack } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useOrganization } from '@/hooks/useOrganization';
import { Header } from './Header';
import { Navbar } from './Navbar';
import { EmailVerificationBanner } from '../ui/EmailVerificationBanner';

export function AppLayout() {
  const [mobileOpened, { toggle: toggleMobile, close: closeMobile }] = useDisclosure();
  const [desktopOpened, { toggle: toggleDesktop }] = useDisclosure(true);
  const { organization } = useOrganization();

  return (
    <AppShell
      header={{ height: 60 }}
      navbar={{
        width: 300,
        breakpoint: 'sm',
        collapsed: { mobile: !mobileOpened, desktop: !desktopOpened },
      }}
      padding="md"
    >
      <AppShell.Header>
        <Group h="100%" px="md" justify="space-between">
          <Group>
            <Burger opened={mobileOpened} onClick={toggleMobile} hiddenFrom="sm" size="sm" />
            <Burger opened={desktopOpened} onClick={toggleDesktop} visibleFrom="sm" size="sm" />
            <Group gap="xs">
              <Image src="/logo.png" alt="TrustPuma" h={32} w="auto" />
            </Group>
          </Group>
          <Header />
        </Group>
      </AppShell.Header>

      <AppShell.Navbar p="md">
        <Navbar onMobileNavClick={closeMobile} />
      </AppShell.Navbar>

      <AppShell.Main>
        <Stack gap={0}>
          <EmailVerificationBanner />
          <Outlet />
        </Stack>
      </AppShell.Main>
    </AppShell>
  );
}
